<template>
  <div class="conteudoTable"> 
            <p  class="txtDadosG">Informações Adicionais</p>
            <div class="dadosGerais" style="display:block;">
                <label for="">Formato de Impressão DANFE</label><br>
                <input type="text" v-model="table.formatoDANFE">
            </div>
            
        <div v-if="table.autorizados.length > 0">
            <p  class="txtDadosG" align="left">Autorizados a acessar o XML da NF-e</p>
            <div class="dadosGerais" style="display:block;">
                <div v-for="(n,i) in table.autorizados" :key="i">
                    <label for="">{{n.tipoDocumento}}</label><br>
                    <input type="text" v-model="n.documento">
                </div>
            </div>
        </div>
        <div v-if="table.informacoesFisco != null">
            <p  class="txtDadosG" align="left">Informações Complementares de Interesse do Fisico</p>
            <div class="dadosGerais" style="display:block;">
                <label for="">Descrição</label><br>
                <textarea style="height:65px;" v-model="table.informacoesFisco"></textarea>
            </div>
        </div>

           <div v-if="table.informacoesComplementares != null">
                <p  class="txtDadosG" align="left">Informações Complementares de Interesse do Contribuinte</p>
                <div class="dadosGerais" style="display:block;">
                    <label for="">Descrição</label><br>
                    <textarea style="height:65px;" v-model="table.informacoesComplementares"></textarea>
                </div>  
            </div>      
            <div v-if="table.responsavelTecnico != null">
                <p  class="txtDadosG" align="left">Informações do Responsável Técnico pela emissão do DF-e</p>
                <div class="dadosGerais tra">
                    <div>
                        <label for="">CNPJ</label><br>
                        <input type="text" v-model="table.responsavelTecnico.cnpj" readonly>
                    </div>
                    <div>
                        <label for="">Nome da pessoa a ser contatada</label><br>
                        <input type="text" v-model="table.responsavelTecnico.nome" readonly>
                    </div>
                    <div>
                        <label for="">E-mail</label><br>
                        <input type="text" v-model="table.responsavelTecnico.email" readonly>
                    </div>
                    <div>
                        <label for="">Telefone</label><br>
                        <input type="text" v-model="table.responsavelTecnico.telefone" readonly>
                    </div>
                </div>
            </div>
             <div v-if="table.observacoesContribuinte.length != 0">

           
                <p  class="txtDadosG" align="left">Observações Complementares de interesse do Contribuinte</p>
                <div class="dadosGerais" >
                    <div style="width:49.5%">
                            <label for="">Campo</label><br>
                            <div v-for="(n,i) in table.observacoesContribuinte" :key="i" style="margin-top:10px;"> 
                                <input type="text"  v-model="n.campo" readonly> 
                            </div>
                        </div>
                        <div style="width:49.5%">  
                            <label for="">Texto</label><br>              
                            <div v-for="(n,i) in table.observacoesContribuinte" :key="i" style="margin-top:10px;"> 
                                <input type="text"  v-model="n.texto" readonly> 
                            </div>
                        </div>                   
                </div>
             </div>
  </div>
</template>

<script>
export default {
    props:['table'],
    data(){
        return{
            
        }
    },
    

}
</script>

<style>
.tra  div{
    width: 24%;
}
textarea:focus{
    outline: none;
}
</style>